import React, { useState } from "react";

const ExportarGrupos = () => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleExportarGrupos = () => {
    // Dados fictícios dos grupos da campanha
    const grupos = [
      { nome: "Grupo A", membros: 50, status: "Ativo" },
      { nome: "Grupo B", membros: 30, status: "Inativo" },
      { nome: "Grupo C", membros: 70, status: "Ativo" },
    ];

    // Converter os dados para CSV
    const csvHeader = "Nome do Grupo,Membros,Status\n";
    const csvRows = grupos.map(grupo => `${grupo.nome},${grupo.membros},${grupo.status}`).join("\n");
    const csvContent = csvHeader + csvRows;

    // Criar um blob para o arquivo CSV
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    // Criar um link para download
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "grupos.csv");
    document.body.appendChild(link);

    // Acionar o download
    link.click();

    // Remover o link após o download
    document.body.removeChild(link);

    // Fechar o modal
    setModalOpen(false);
  };

  return (
    <div>
      {/* Botão para abrir o modal */}
      <button
        onClick={() => setModalOpen(true)}
        style={{
          background: "#51a197",
          color: "#fff",
          border: "none",
          borderRadius: 8,
          padding: "10px 20px",
          fontWeight: "bold",
          fontSize: 16,
          cursor: "pointer",
        }}
      >
        Exportar Grupos
      </button>

      {/* Modal */}
      {modalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 12,
              padding: 24,
              width: "90%",
              maxWidth: 400,
              boxShadow: "0 2px 16px rgba(0, 0, 0, 0.2)",
              textAlign: "center",
            }}
          >
            <h2 style={{ color: "#005c53", fontWeight: "bold", marginBottom: 16 }}>
              Exportar Grupos
            </h2>
            <p style={{ color: "#333", fontSize: 16, marginBottom: 24 }}>
              Tem certeza que deseja exportar os grupos da campanha?
            </p>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  background: "#e0e0e0",
                  color: "#005c53",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 20px",
                  fontWeight: "bold",
                  fontSize: 16,
                  cursor: "pointer",
                  flex: 1,
                }}
              >
                Não
              </button>
              <button
                onClick={handleExportarGrupos}
                style={{
                  background: "#51a197",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 20px",
                  fontWeight: "bold",
                  fontSize: 16,
                  cursor: "pointer",
                  flex: 1,
                }}
              >
                Sim
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExportarGrupos;